function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.2678 14.6738L9.77812 75.2095C7.4606 79.5276 10.5984 84.75 15.5104 84.75H80.4896C85.4016 84.75 88.5394 79.5276 86.2219 75.2095L53.7322 14.6738C51.2822 10.1087 44.7178 10.1087 42.2678 14.6738Z",
  fill: "#F8B755"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_824:42970)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.7099 56.9719C52.5921 59.0915 50.839 60.75 48.7161 60.75L47.2839 60.75C45.161 60.75 43.4079 59.0915 43.2901 56.9719L42.2345 37.9719C42.1072 35.6791 43.9321 33.75 46.2284 33.75L49.7716 33.75C52.0679 33.75 53.8928 35.6791 53.7654 37.9719L52.7099 56.9719Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("rect", {
  x: 52.5,
  y: 75.75,
  width: 9,
  height: 9,
  rx: 4.5,
  transform: "rotate(180 52.5 75.75)",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_824:42970"
}, /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  fill: "white",
  transform: "translate(27 33.75)"
})));

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.6ddcfb08.svg";
export { ForwardRef as ReactComponent };